<template>
	<div v-if="andonNameSelectedId == null || andonNameSelectedId == ''" class="dashboard-content">
		<div class="d-flex py-1 mb-2">
			<div class="dashboard-logo px-3">
				<b-img :src="`${publicPath}/img/maruhide-logo.png`" class="logo"></b-img>
			</div>
			<div class="dashboard-title flex-grow-1 d-flex justify-content-center align-items-center">
				<TextViewer idName="text-title" :value="`ACHIVEMENT MONITORING`" className="text-title" />
			</div>
		</div>
		<div class="d-flex align-items-center px-3 flex-column">
			<b-button v-for="(item, index) in andonNames" :key="index" @click="getAndonProductionData(item.id, item.andon_name)" :variant="(andonNameSelectedId == item.id ? 'success' : 'light')" size="sm" class="w-25 mb-3" ><h4 class="m-0">{{ item.andon_name }}</h4></b-button>
			<b-spinner v-if="isProcessLoading" variant="light" label="Spinning"></b-spinner>
		</div>
	</div>
	<div v-else class="dashboard-content">
		<div v-if="isLoading" class="loading-data">
			<b-spinner variant="light" label="Get Data"></b-spinner> loading...
		</div>
		<div class="d-flex py-1 mb-1">
			<div role="button" @click="backToMenu()" class="dashboard-logo px-3">
				<b-img :src="`${publicPath}/img/maruhide-logo.png`" class="logo"></b-img>
			</div>
			<div class="dashboard-title flex-grow-1 d-flex justify-content-center align-items-center">
				<TextViewer idName="text-title" :value="`ACHIVEMENT MONITORING ${andonNameSelected} LINE`" className="text-title" />
			</div>
		</div>
		<div class="d-flex justify-content-end align-items-center mb-2">
			<div class="px-3 production-date">
				Production Date {{ getToday() }}
			</div>
		</div>
		<SlideShow :slides="dataChart" @change="onChange">
			<template v-slot:default="itemData">
				<ColumnViewer idName="column2" className="column2 col-12 mb-3 slide">
					<div id="card3" class="d-flex justify-content-center">
						<CardViewer className="card3 p-0">
							<div id="row4" class="row row4 m-0 border-bottom-white justify-content-between px-1">
								<ColumnViewer idName="column5" className="column5">
									<TextViewer idName="text7" :value="itemData.data.name" className="text7" />
								</ColumnViewer>
								<ColumnViewer idName="column6" className="column column6 d-flex justify-content-end px-1 align-items-center">
									<TextViewer idName="text8" :value="'last update ' + (itemData.data.data != null && itemData.data.data != undefined ? formatDate(itemData.data.data.lastUpdateDate, 'HH:mm') : '')" className="text8" />
									<div :class="'div-machine-status ml-2' + (itemData.data.data.lampIndicator ? ' div-machine-status-on' : ' div-machine-status-off')  "></div>
								</ColumnViewer>
							</div>
							<div id="row9" class="row row9 m-0">
								<ColumnViewer idName="column10" className="column10 col-6 border-right-dashed-white p-0">
									<TextViewer idName="text13" value="TOTAL ACHIEVEMENT" className="text13 w-100 border-bottom-dashed-white h-text-title" />
									<div class=" border-bottom-dashed-white h-card d-flex justify-content-center flex-column">
										<div v-if="true" class="div-gauge-image px-3 w-100 d-flex justify-content-center">
											<b-img v-if="itemData.data.data.productAchievementPercentage < 30" :src="`${publicPath}/img/gauge-poor.png`" class="gauge-image"></b-img>
											<b-img v-else-if="itemData.data.data.productAchievementPercentage > 70" :src="`${publicPath}/img/gauge-good.png`" class="gauge-image"></b-img>
											<b-img v-else :src="`${publicPath}/img/gauge-average.png`" class="gauge-image"></b-img>
										</div>
										<div v-if="false" class="div-gauge-image px-3 w-100 d-flex justify-content-center">
											<b-img :src="`${publicPath}/img/background_gauge.png`" class="gauge-image"></b-img>
											<b-img :src="`${publicPath}/img/arrow.png`" class="arrow-image"></b-img>
										</div>
										<TextViewer idName="text14" :value="itemData.data.data.productAchievementPercentage + '%'" className="text14 w-100" />
									</div>
									<TextViewer idName="text16" value="LOSSTIME MONITORING" className="text16 w-100 border-bottom-dashed-white h-text-title" />
									<div class="piechart17">
										<PieChartViewer idName="piechart17" 
											:chartOptions="piechart17Options"
											:dataChart="itemData.data.data.lostTimeMonitoring"
											chartLabel="standar_time_name"
											chartValue="jumlah_loss_time"
											labelType="VALUE"
											className="piechart17" />
									</div>
								</ColumnViewer>
								<ColumnViewer idName="column12" className="column12 col-6 p-0">
									<div id="row18" class="row row18 border-bottom-dashed-white m-0">
										<ColumnViewer idName="column20" className="column20 col-7 p-0 border-right-dashed-white">
											<TextViewer idName="text16" value="TODAY QTY ACHIEVEMENT" className="text16 border-bottom-dashed-white h-text-title" />
											<BarChartViewer idName="barchart25" :chartOptions="barchart25Options"
												className="barchart25"
												:chartSeries="getChartSeries(itemData.data.data.qtyAchievement, 'count', 'name')"
												chartLabel="name"
												chartValue="count"
												/>
										</ColumnViewer>
										<ColumnViewer idName="column21" className="column21 col-5 p-0">
											<TextViewer idName="text16" :value="processTypeSelected == 'WELDING' || processTypeSelected == 'ASSY' ? 'WPAH' : 'SPH'" className="text16 border-bottom-dashed-white h-text-title" />
											<TextViewer idName="text26" value="TARGET" className="text26" />
											<div id="card27" class="p-1">
												<CardViewer className="card27 d-flex justify-content-center align-items-center">
													<TextViewer idName="text2" :value="formatNumber(itemData.data.data.sphTarget)" className="text2" />
												</CardViewer>
											</div>
											<TextViewer idName="text28" value="ACTUAL" className="text28" />
											<div id="card29" class="p-1">
												<CardViewer className="card29 d-flex justify-content-center align-items-center">
													<TextViewer idName="text3" :value="formatNumber(itemData.data.data.sphActual)" className="text3" />
												</CardViewer>
											</div>
										</ColumnViewer>
									</div>
									<div id="card22" class="row row18 border-bottom-dashed-white m-0">
										<ColumnViewer idName="column20" className="column20 col-7 p-0 border-right-dashed-white">
											<TextViewer idName="text30" value="DELAY QTY" className="text30 border-bottom-dashed-white h-text-title" />
											<BarChartViewer idName="barchart25" :chartOptions="barchart25Options"
												className="barchart25"
												:chartSeries="getChartSeries(itemData.data.data.qtyDelayBarchart, 'count', 'name')"
												chartLabel="name"
												chartValue="count"
												/>
										</ColumnViewer>
										<ColumnViewer idName="column21" className="column21 col-5 p-0">
											<TextViewer idName="text33" value="NG QTY" className="text33 border-bottom-dashed-white h-text-title" />
											<div class="m-1">&nbsp;</div>
											<div id="card27" class="p-1">
												<CardViewer className="card27 d-flex justify-content-center align-items-center">
													<TextViewer idName="text2" :value="formatNumber(itemData.data.data.ngQty)" className="text2" />
												</CardViewer>
											</div>
										</ColumnViewer>
										<!-- <CardViewer className="card22">
											<TextViewer idName="text30" value="DELAY QTY" className="text30" />
											<div id="card31">
												<CardViewer className="card31 d-flex justify-content-center align-items-center">
													<TextViewer idName="text4" :value="formatNumber(itemData.data.data.delayQty)" className="text4" />
												</CardViewer>
											</div>
											<TextViewer idName="text33" value="NG QTY" className="text33" />
											<div id="card34">
												<CardViewer className="card34 d-flex justify-content-center align-items-center">
													<TextViewer idName="text5" :value="formatNumber(itemData.data.data.ngQty)" className="text5" />
												</CardViewer>
											</div>
										</CardViewer> -->
									</div>
								</ColumnViewer>
							</div>
						</CardViewer>
					</div>
				</ColumnViewer>
			</template>
		</SlideShow>
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/dashboard-page.scss';
@import '../../assets/dashboardcss/andonproduction.scss';
</style>
<script>
import ListViewer from '@/components/dashboard/ListViewer';
import ColumnViewer from '@/components/dashboard/ColumnViewer';
import CardViewer from '@/components/dashboard/CardViewer';
import RowViewer from '@/components/dashboard/RowViewer';
import TextViewer from '@/components/dashboard/TextViewer';
import PieChartViewer from '@/components/dashboard/PieChartViewer';
import BarChartViewer from '@/components/dashboard/BarChartViewerCustom';
import moment from 'moment';
import { thousandSeparator } from '@/utils/thousandSeparator';
import SlideShow from './components/SlideShow';

export default {
	components: {
		ListViewer, ColumnViewer, CardViewer, RowViewer, TextViewer, PieChartViewer, BarChartViewer, SlideShow
	},
	data() {
		return {
			piechart17Options: {
				"legend": true,
				legendPosition: "left"
			},
			barchart25Options: {
				"xaxisLabel": true,
				"yaxisLabel": false
			},
			isLoading: false,
			isProcessLoading: false,
			dataChart: [],
			processTypes: [],
			processTypeSelected: '',
			andonNames: [],
			andonNameSelectedId: '',
			andonNameSelected: '',
		}
	},
	mounted() {
		this.getAndonName();
	},
	methods: {
		getAndonProductionData(andonId, andonName) {
			let this_ = this;
			this.isLoading = true;
			this.andonNameSelectedId = andonId;
			this.andonNameSelected = andonName;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonproductiondata/${andonId}`).then(result => {
				if (result != null) {
					this_.dataChart = result.data;
				}
				this_.isLoading = false;
				return true;
			}).catch(function (error) {
				this_.isLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		getAndonProcessType() {
			this.isProcessLoading = true;
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonprocesstype`).then(result => {
				if (result != null) {
					this_.processTypes = result.data;
					if (this.processTypes != null && this.processTypes.length > 0) {
						let processType = this.processTypes[0]["code"];
						this_.processTypeSelected = processType;
						this_.getAndonProductionData(processType);
						//this.getAndonInterval();
					}
				}
				this_.isProcessLoading = false;
				return true;
			}).catch(function (error) {
				this_.isProcessLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		getAndonName() {
			this.isProcessLoading = true;
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonname`).then(result => {
				if (result != null) {
					this_.andonNames = result.data;
				}
				this_.isProcessLoading = false;
				return true;
			}).catch(function (error) {
				this_.isProcessLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		formatDate(date, formatString) {
			return moment(date).format(formatString);
		},
		getToday() {
			const today = moment().format('D MMMM YYYY');
			return today;
		},
		getChartSeries(chartData, chartValue, chartLabel) {
			let result = [];
			let actualCount = 0;

			const processItem = (item, seriesName, xValue, yValue, color) => {
				return {
					x: xValue,
					y: yValue,
					color: color
				};
			};

			const filterAndProcessData = (conditionCallback, processCallback) => {
				return chartData.filter(conditionCallback).map(processCallback);
			};

			// Process 'Plan' series
			let planData = filterAndProcessData(
				item => item[chartLabel] !== "ActualPending",
				item => {
					if (item[chartLabel] === "ActualGood" || item[chartLabel] === "Gap") {
						return processItem(item, 'Plan', item[chartLabel] === "ActualGood" ? "Actual" : "Gap", [1, 0]);
					} else {
						if (item[chartLabel] === "Actual") {
							actualCount = parseInt(item[chartValue]);
						}
						return processItem(
							item,
							'Plan',
							item[chartLabel],
							[1, parseInt(item[chartValue])],
							'#47DF8D'
						);
					}
				}
			);

			result.push({ name: 'Plan', data: planData });

			// Process 'Actual Good' series
			let actualGoodData = filterAndProcessData(
				item => item[chartLabel] !== "ActualPending",
				item => {
					if (item[chartLabel] === "Plan" || item[chartLabel] === "Gap") {
						return processItem(item, 'Actual Good', item[chartLabel], [1, 0]);
					} else {
						return processItem(item, 'Actual Good', "Actual Good", [1, parseInt(item[chartValue])], '#DFBD47');
					}
				}
			);

			result.push({ name: 'Actual Good', data: actualGoodData });

			// Process 'Actual Pending' series
			let actualPendingData = filterAndProcessData(
				item => item[chartLabel] !== "ActualGood",
				item => {
					if (item[chartLabel] === "Plan" || item[chartLabel] === "Gap") {
						return processItem(item, 'Actual Pending', item[chartLabel], [1, 0]);
					} else {
						return processItem(item, 'Actual Pending', "Actual Pending", [1, parseInt(item[chartValue])], '#7D12CC');
					}
				}
			);

			result.push({ name: 'Actual Pending', data: actualPendingData });

			// Process 'Gap' series
			let gapData = filterAndProcessData(
				item => item[chartLabel] !== "ActualPending",
				item => {
					if (item[chartLabel] === "ActualGood" || item[chartLabel] === "Plan") {
						return processItem(item, 'Gap', item[chartLabel] === "ActualGood" ? "Actual" : "Plan", [1, 0]);
					} else {
						if (item[chartLabel] === "Gap") {
							return processItem(item, 'Gap', "Gap", [actualCount, parseInt(item[chartValue])], '#D40888');
						}
						return processItem(item, 'Gap', item[chartLabel], [1, parseInt(item[chartValue])], '#D40888');
					}
				}
			);

			result.push({ name: 'Gap', data: gapData });

			return result;
		},
		getChartCategories(chartData, chartLabel) {
			const labels = chartData.map(data => data[chartLabel]);
			return labels;
		},
		formatNumber(value) {
            return thousandSeparator(value);
        },
		getAndonInterval() {
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonrefreshinterval`).then(result => {
				if (result != null) {
					if(result.data != null) {
						if (result.data.interval != null && result.data.interval != undefined
							 && result.data.interval > 0) {
							this_.runAutorefresh(result.data.interval);
						}
					}
				}
				return true;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		runAutorefresh(interval) {
			let this_ = this;
			setInterval(() => {
				this_.getAndonProductionData(this.andonNameSelectedId, this.andonNameSelected);
			}, (1000 * 60 * interval));
		},
		onChange(result) {
			let this_ = this;
			this_.getAndonProductionData(this.andonNameSelectedId, this.andonNameSelected);
		},
		backToMenu() {
			this.andonNameSelectedId = null;
			this.dataChart = [];
		}
	},
}
</script>